import type { AppState, AttendanceRecord, CoursePeriod } from './types'

export const secureToken = () => {
  const bytes = crypto.getRandomValues(new Uint8Array(24))
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('')
}

export function findSuggestedSession(state: AppState, periodId: string) {
  const sessions = state.sessions.filter((session) => session.periodId === periodId && session.status === 'DRAFT').sort((a, b) => a.week - b.week || a.sessionNumber - b.sessionNumber)
  const today = new Date().toLocaleDateString('en-CA', { timeZone: 'America/Lima' })
  return sessions.find((session) => session.date === today) ?? sessions[0]
}

export function sessionCode(week: number, sessionNumber: number) {
  return `W${String(week).padStart(2, '0')}-S${sessionNumber}`
}

export function sumForEnrollment(state: AppState, enrollmentId: string, period: CoursePeriod) {
  const sessionIds = new Set(period.sessionIds)
  return state.attendance
    .filter((record) => record.enrollmentId === enrollmentId && sessionIds.has(record.sessionId) && typeof record.value === 'number')
    .reduce((sum, record) => sum + Number(record.value), 0)
}

export function effectiveRecord(state: AppState, sessionId: string, enrollmentId: string): AttendanceRecord | undefined {
  return state.attendance.find((record) => record.sessionId === sessionId && record.enrollmentId === enrollmentId)
}

export function isValidAttendanceToken(state: AppState, token: string, now = Date.now()) {
  const item = state.attendanceTokens.find((candidate) => candidate.token === token)
  if (!item || item.expiresAt <= now) return false
  const session = state.sessions.find((session) => session.id === item.sessionId)
  return session?.status === 'ACTIVE' && (session.closesAt ?? 0) > now
}

export function isValidLinkToken(state: AppState, token: string, now = Date.now()) {
  const display = state.displays.find((candidate) => candidate.linkToken === token)
  return Boolean(display && !display.consumed && display.tokenExpiresAt > now && display.state === 'UNLINKED')
}
